/**
 * 【KYMW1400】コマ商品情報登録VO
 *
 * @export RegistKomaGoodsModel
 * @class RegistKomaGoodsModel
 */
export class RegistKomaGoodsModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   * ページ番号
   */
  public pageNum = Number(0);

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = String('');

  /**
   * コマ情報VO
   */
  public komaInfoVOList: Array<any> = new Array<any>();
}
